import PropTypes from 'prop-types';
import React from 'react';
import {
  DrawerWrapper,
  Header,
  HeaderTitle,
  HeaderClose,
  Image,
  CtaWrapper,
  CtaLeft,
  CtaRight,
  CtaTitle,
  CtaText,
  CtaLink,
  MobileSecondaryClose,
} from './Drawer.styled';

class Drawer extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.data !== nextProps.data) {
      return true;
    }

    if (this.props.drawerExpanded !== nextProps.drawerExpanded) {
      return true;
    }

    return false;
  }

  render() {
    const { data } = this.props;
    if (!data) return null;

    return (
      <DrawerWrapper
        expanded={this.props.drawerExpanded}
        className={this.props.drawerExpanded ? 'drawer is-expanded' : 'drawer'}
        id="ifp-drawer"
      >
        <Header>
          <HeaderTitle>{data.title}</HeaderTitle>
          <HeaderClose onClick={this.props.toggleDrawer}>Close</HeaderClose>
        </Header>

        {data.images.map((image, index) => {
          if (!image) return null;
          return (
            <Image className="image" key={index} src={image} alt="Image" />
          );
        })}

        {data.show ? (
          <span>
            {data.title !== 'Open Floor Plan' ? (
              <CtaWrapper>
                {data.ctaThumb && (
                  <CtaLeft className="cta-left" img={data.ctaThumb}></CtaLeft>
                )}

                <CtaRight className="cta-right">
                  <CtaTitle>On Clayton Studio</CtaTitle>
                  <CtaText>{data.ctaText || ''}</CtaText>
                  <CtaLink href={data.ctaUrl}>Learn More &gt;</CtaLink>
                </CtaRight>
              </CtaWrapper>
            ) : (
              <CtaWrapper>
                {data.ctaThumb && (
                  <CtaLeft className="cta-left" img={data.ctaThumb}></CtaLeft>
                )}

                <CtaRight className="cta-right">
                  <CtaLink href={data.ctaUrl} target="_blank">
                    Find A Home &gt;
                  </CtaLink>
                </CtaRight>
              </CtaWrapper>
            )}
          </span>
        ) : null}

        <MobileSecondaryClose onClick={this.props.toggleDrawer}>
          Back to Floor Plan
        </MobileSecondaryClose>
      </DrawerWrapper>
    );
  }
}

Drawer.propTypes = {
  data: PropTypes.shape({
    ctaText: PropTypes.string,
    ctaThumb: PropTypes.any,
    ctaUrl: PropTypes.any,
    images: PropTypes.array,
    show: PropTypes.any,
    title: PropTypes.string,
  }),
  drawerExpanded: PropTypes.any,
  toggleDrawer: PropTypes.any,
};

export default Drawer;
